(function () {
  // Mobile navigation
  document.querySelectorAll('[data-nav-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var header = btn.closest('.site-header');
      var open = header.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // Portfolio filters
  document.querySelectorAll('[data-work]').forEach(function (root) {
    var buttons = root.querySelectorAll('[data-filter]');
    var items = root.querySelectorAll('[data-category]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-filter');
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        items.forEach(function (item) {
          var cats = (item.getAttribute('data-category') || '').split(' ');
          item.hidden = value !== 'all' && cats.indexOf(value) === -1;
        });
      });
    });
  });
})();
